import { Formatters, NumberFormat } from '@billy/design-system'

interface FormatAmountWithCurrencyProps {
  amount: number
  currency?: string
  locale?: string
}

export const formatAmountWithCurrency = ({
  amount,
  locale = 'nl_NL',
  currency = 'EUR',
}: FormatAmountWithCurrencyProps) => {
  const numberFormatLocale = Formatters.getFormatLocale(locale)

  return NumberFormat.getFormattedNumber(amount, numberFormatLocale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
}
